import { useEffect } from 'react';

//index.scss puts overflow-x on <html>, making it the page scroll container — PrimeReact's
//blockScroll only touches <body>, so a viewport lock has to land on documentElement.
export function useViewportScrollLock() {
  useEffect(() => {
    const html = document.documentElement;
    const prev = html.style.overflowY;
    html.style.overflowY = 'hidden';
    return () => {
      html.style.overflowY = prev;
    };
  }, []);
}
